import React, { useRef } from 'react';
import { Popover, Tooltip } from 'antd';
import { ButtonGroup } from 'react-rainbow-components';
import { FontstyleComboboxContainer, SizeButton, SizeContainer } from '../styles';
import { CHART_TRANSLATION } from '../translationValues';
import { ChartColorPicker } from '../chartColorPicker';

const fontSizes = [8, 9, 10, 12, 14, 16, 20, 24, 32, 42, 54, 68, 84, 98];

export const FontstyleCombobox = ({ t, fontSize, onSizeChange, fontColor, onColorChange }) => {
  const inputRef = useRef();

  const handleKeypress = e => {
    e.stopPropagation();
    if (['Enter', 'ArrowDown', 'ArrowUp'].includes(e.key)) {
      e.preventDefault();
      const value = parseFloat(inputRef.current.innerHTML.trim());
      if (!isNaN(value) && value >= 1 && value <= 400) {
        onSizeChange(value);
      }
    }
  };

  return (
    <FontstyleComboboxContainer>
      <Tooltip
        placement="top"
        title={t(
          CHART_TRANSLATION.FONT_COLOR_TOOLTIP.key,
          CHART_TRANSLATION.FONT_COLOR_TOOLTIP.value,
        )}
      >
        <ChartColorPicker fontColor={fontColor} onColorChange={onColorChange} />
      </Tooltip>
      <Tooltip
        placement="top"
        title={t(
          CHART_TRANSLATION.FONT_SIZE_TOOLTIP.key,
          CHART_TRANSLATION.FONT_SIZE_TOOLTIP.value,
        )}
      >
        <span>
          <ButtonGroup>
            <SizeButton
              comboBox={1}
              isMinus={1}
              onClick={() => {
                if (!isNaN(fontSize)) {
                  onSizeChange(fontSize - 1);
                }
              }}
              icon="minus"
            />
            <Popover
              content={
                <SizeContainer>
                  <ul>
                    {fontSizes.map(data => (
                      <li
                        key={data}
                        onClick={e => {
                          onSizeChange(data);
                        }}
                      >
                        {`${data}px`}
                      </li>
                    ))}
                  </ul>
                </SizeContainer>
              }
              title={null}
              trigger="click"
            >
              <div
                ref={inputRef}
                contentEditable={true}
                suppressContentEditableWarning={true}
                style={{
                  width: '50px',
                  border: '1px solid #d9d9d9',
                  color: 'black',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  background: 'white',
                }}
                onKeyPress={handleKeypress}
                onBlur={e => {
                  const value = parseFloat(inputRef.current.innerHTML.trim());
                  if (value !== fontSize && !isNaN(value) && value >= 1 && value <= 400) {
                    onSizeChange(value);
                  }
                }}
              >
                {!isNaN(fontSize) && fontSize ? fontSize : ' '}
              </div>
            </Popover>
            <SizeButton
              comboBox={1}
              isMinus={1}
              style={{ borderRadius: 0 }}
              onClick={() => {
                if (!isNaN(fontSize)) {
                  onSizeChange(fontSize + 1);
                }
              }}
              icon="plus"
            />
          </ButtonGroup>
        </span>
      </Tooltip>
    </FontstyleComboboxContainer>
  );
};
